<samweb-calling-toast-dialog
   [stateValue]="state.value"
   [leftIconDisabled]="!(isCallRingingAndAcceptable$ | async)"
   [rightIconDisabled]="!(canDisconnectLineA$ | async)"
   [samWiggle]="true"
   [leftIcon]="answerIcon"
   [rightIcon]="declineIcon"
   [progressBar]="options.progressBar"
   (leftButtonClick)="acceptCall()"
   (rightButtonClick)="declineCall()"
>
   <div>
      <div *ngIf="currentCallShortInfo$ | async; let callInfo" class="sam-form-row">
         <div>
            <samweb-skill-short-info
               [skills]="(skillGroup$ | async)?.skills"
               [skillConfiguration]="(skillGroup$ | async)?.skillConfiguration"
            >
            </samweb-skill-short-info>
         </div>
         <div
            [ngClass]="callInfo.peerName.length > 0 ? 'main-text' : 'sub-text'"
            *ngIf="!(callInfo.peerId | isAnonymous) && callInfo.peerId !== ''"
         >
            {{ callInfo.peerName }}
         </div>
         <div [ngClass]="(callInfo.peerId | isAnonymous) ? 'main-text' : 'sub-text'">
            <ng-container *ngIf="(callInfo.peerId | isAnonymous) || callInfo.peerId === ''">
               {{ 'common.calling.unknown_number' | translate }}
            </ng-container>
            <ng-container *ngIf="!(callInfo.peerId | isAnonymous) && callInfo.peerId !== ''">
               {{ callInfo.peerId }}
            </ng-container>
         </div>
      </div>
   </div>
</samweb-calling-toast-dialog>
